<template>
  <div class="productSelection">
    <div v-if="id">
      <div class="topBox">
        <h3>
          {{ info.lectotypeInquiryNo }}
          <Copyable :text="info.lectotypeInquiryNo" />
          <el-button
            v-if="[3, 7, 9].includes(info.status)"
            type="primary"
            size="mini"
            style="margin-left: 10px"
            @click="goSubmit"
            >去下单</el-button
          >
        </h3>
        <div style="width: 480px">
          <el-steps
            :active="stepActive"
            finish-status="success"
            process-status="process"
            :align-center="true"
          >
            <el-step
              v-for="(item, index) in stepList"
              :key="index"
              :title="item"
            ></el-step>
          </el-steps>
        </div>
      </div>
      <el-descriptions>
        <el-descriptions-item label="客户名称">{{
          info.customerName
        }}</el-descriptions-item>
        <el-descriptions-item label="企业状态">{{
          getCustomerStatusLabel(info.customerStatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          info.createTime
        }}</el-descriptions-item>
        <el-descriptions-item label="发起人">{{
          info.createUserName
        }}</el-descriptions-item>
        <el-descriptions-item label="选型商品数量">{{
          info.recordNumber
        }}</el-descriptions-item>
        <el-descriptions-item label="需求备注">{{
          info.remark
        }}</el-descriptions-item>
      </el-descriptions>
      <el-table
        :data="dataList"
        key="inquiryTable"
        v-loading="dataLoading"
        border
      >
        <div class="no_show_message" slot="empty">
          <img src="@/assets/img/good/noGood.png" alt="暂无相关询价单" />
          <div>暂无数据</div>
        </div>
        <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="序号"
        >
          <template slot-scope="scope">
            {{ (dataForm.page - 1) * dataForm.limit + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          label="商品信息"
          width="130px"
        >
          <template slot-scope="scope">
            <Tooltip style="font-weight: bold" :innerContent="scope.row.spuName || '-'" />
            <div style="display: flex;white-space:nowrap;">
              品牌：
              <Tooltip :innerContent="scope.row.brandName || '-'" />
            </div>
            <div style="display: flex;white-space:nowrap;">
              系列：
              <Tooltip :innerContent="scope.row.seriesName || '-'" />
            </div>
            <div style="display: flex;white-space:nowrap;">
              订货号：
              <Tooltip :innerContent="scope.row.spuCode || '-'" />
            </div>
            <div style="display: flex;white-space:nowrap;">
              最小起订量：
              <Tooltip :innerContent="scope.row.moq || '-'" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recordStatus"
          header-align="center"
          align="center"
          label="子状态"
        >
          <template slot-scope="scope">
            {{ getRecordStatusLabel(scope.row.recordStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="attributeInfoList"
          header-align="center"
          align="center"
          label="详细参数"
          width="200px"
        >
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.attributeInfoList.length">
                {{ scope.row.attributeInfoList[0].attributeItemName }}:{{
                  scope.row.attributeInfoList[0].attributeValueName
                }}
                <el-button
                  type="text"
                  icon="el-icon-view"
                  @click="onShowAllAttr(scope.row.attributeInfoList)"
                ></el-button>
              </div>
              <div v-else>-</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recordRemark"
          header-align="center"
          align="center"
          label="需求备注"
          show-overflow-tooltip
          width="160px"
        >
        </el-table-column>
        <el-table-column
          prop="number"
          header-align="center"
          align="center"
          label="需求数量"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="quotePrice"
          header-align="center"
          align="center"
          label="报价"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="replyTime"
          header-align="center"
          align="center"
          label="回复时间"
          width="160px"
        >
        </el-table-column>
        <el-table-column
          prop="reply"
          header-align="center"
          align="center"
          label="需求回复"
          width="160px"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="[0, 2, 7].includes(+info.status)"
          header-align="center"
          align="center"
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="onUpdateRecordType(scope.row, 5)"
              v-if="scope.row.recordStatus == 0"
              >取消</el-button
            >
            <!-- 已报价 展示 -->
            <el-button
              type="text"
              size="small"
              @click="onUpdateRecordType(scope.row, 3)"
              v-if="scope.row.recordStatus == 2"
              >确认</el-button
            >
            <!-- 已报价 展示 -->
            <el-button
              type="text"
              size="small"
              @click="onUpdateRecordType(scope.row, 4)"
              v-if="scope.row.recordStatus == 2"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="dataForm.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="dataForm.limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
    <div v-else>
      <el-empty description="无此内容"></el-empty>
    </div>
    <el-dialog
      :visible.sync="activeTip.visible"
      title="提示"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="480px"
    >
      <h3>
        请再次确认是否继续执行【{{
          ["待受理", "处理中", "未受理", "确认", "拒绝", "取消"][
            activeTip.status
          ]
        }}】操作！
      </h3>
      <template slot="footer">
        <el-button @click="activeTip.visible = false">取消</el-button>
        <el-button type="primary" @click="updateRecordType(5)">确定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      :visible.sync="attrList.visible"
      title="详细参数"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="480px"
    >
      <el-table :data="attrList.showList" border>
        <div class="no_show_message" slot="empty">
          <img src="@/assets/img/good/noGood.png" alt="暂无数据" />
          <div>暂无数据</div>
        </div>
        <el-table-column
          prop="attributeItemName"
          header-align="center"
          align="center"
          label="属性名"
        >
        </el-table-column>
        <el-table-column
          prop="attributeValueName"
          header-align="center"
          align="center"
          label="需求属性值"
        >
          <template slot-scope="scope">
            {{ scope.row.attributeValueName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="srmAttributeValueName"
          header-align="center"
          align="center"
          label="结果属性值"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.attributeValueName !== scope.row.srmAttributeValueName
              "
              style="color: #d9001b"
            >
              {{ scope.row.srmAttributeValueName || "-" }}
            </span>
            <span v-else>
              {{ scope.row.srmAttributeValueName || "-" }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="attrList.page"
        :page-size="attrList.pageSize"
        :total="attrList.list.length"
        layout="total,prev, pager, next"
        @current-change="attrPageChangeHandle"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import Copyable from '@/components/copyable.vue'
import Tooltip from '@/components/tooltipShow/index'
const Base64 = require('js-base64').Base64
export default {
  name: 'productSelectionDetail', // 询价列表页
  components: { Copyable, Tooltip },
  data () {
    return {
      dataLoading: false,
      inquiryStatusList: [
        // 0待受理 1处理中 2已报价 3全部确认 4全部拒绝 5已取消 6不受理 7部分确认 8已询价 9部分转单 10全部转单
        {
          value: '0',
          label: '待受理'
        },
        {
          value: '1',
          label: '处理中'
        },
        {
          value: '8',
          label: '处理中' // 已询价
        },
        {
          value: '2',
          label: '已报价'
        },
        {
          value: '3',
          label: '全部确认'
        },
        {
          value: '7',
          label: '部分确认'
        },
        {
          value: '4',
          label: '全部拒绝'
        },
        {
          value: '5',
          label: '已取消'
        },
        {
          value: '6',
          label: '不受理'
        },
        {
          value: '9',
          label: '部分转单'
        },
        {
          value: '10',
          label: '全部转单'
        }
      ],
      // 明细状态 0待受理 1处理中 2未受理 3已报价 4全部确认 5已取消
      recordStatus: [
        { value: 0, label: '待受理' },
        { value: 1, label: '处理中' },
        { value: 8, label: '处理中' }, // 已询价
        { value: 2, label: '已报价' },
        { value: 3, label: '已确认' },
        { value: 4, label: '已拒绝' },
        { value: 5, label: '已取消' },
        { value: 6, label: '不受理' },
        { value: 11, label: '已转单' }
      ],
      customerStatus: [
        /// 企业状态（10 未认证、20 待认证、30 驳回、40 已认证 50不存在）
        {
          value: '10',
          label: '未认证'
        },
        {
          value: '20',
          label: '待认证'
        },
        {
          value: '30',
          label: '驳回'
        },
        {
          value: '40',
          label: '已认证'
        },
        {
          value: '50',
          label: '不存在'
        }
      ],
      dataForm: {
        page: 1,
        limit: 10
      },
      info: {},
      total: 0,
      dataList: [],
      activeTip: {
        data: null,
        visible: false,
        status: null
      },
      id: '',
      attrList: {
        visible: false,
        list: [],
        showList: [],
        page: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    // 结果有四种 不受理 全部确认 部分确认 全部拒绝
    // 不受理 步骤前面只有 待受理
    // 全部确认 部分确认 全部拒绝 都必须走完 待受理 处理种 已报价
    stepList () {
      const item = this.inquiryStatusList.find(
        (i) => i.value === this.info.status + ''
      )
      const arr = ['待受理', '处理中', '已报价']
      if (!item || [0, 1, 2, 8].includes(+item.value)) {
        // 默认状态
        return [...arr, '全部确认']
      } else if ([9, 10].includes(+item.value)) {
        // 不受理状态
        if (item.value === '9') {
          return [...arr, '部分确认', '部分转单']
          // 其他状态
        } else if (item.value === '10') {
          return [...arr, '全部确认', '全部转单']
        }
      } else {
        // 不受理状态
        if (item.value === '6') {
          return ['待受理', '不受理']
          // 其他状态
        } else {
          return [...arr, item.label]
        }
      }
    },
    stepActive () {
      const item = this.inquiryStatusList.find(
        (i) => i.value === this.info.status + ''
      )
      if (!item) {
        return 0
      } else {
        switch (item.value) {
          case '0':
            return 0
          case '1':
            return 1
          case '8':
            return 1
          case '2':
            return 3
          case '3':
            return 4
          case '7':
            return 4
          case '4':
            return 4
          case '5':
            return 4
          case '6':
            return 4
          case '9':
            return 5
          case '10':
            return 5
          default:
            return 0
        }
      }
    }
  },
  created () {
    const { id } = this.$route.query
    if (!id) {
      return
    }
    this.id = Base64.decode(id)
    this.getInfo()
  },
  methods: {
    attrPageChangeHandle (page = this.attrList.page) {
      this.attrList.page = page
      this.attrList.showList = this.attrList.list.slice(
        (this.attrList.page - 1) * this.attrList.pageSize,
        this.attrList.page * this.attrList.pageSize
      )
    },
    onShowAllAttr (arr) {
      this.attrList.list = arr
      // this.attrList.list = Array.from({ length: 110 }, () => arr[0]);
      this.attrList.page = 1
      this.attrPageChangeHandle()
      this.attrList.visible = true
    },
    onUpdateRecordType (data, status) {
      console.log(data)
      this.activeTip.data = data
      this.activeTip.status = status
      this.activeTip.visible = true
    },
    // 3确认 4拒绝 5取消
    updateRecordType () {
      const obj = {
        recordId: this.activeTip.data.recordId,
        // 已取消
        recordStatus: this.activeTip.status
      }
      const that = this
      this.$http
        .post(
          `/front/commodity/manager/lectotypeInquiry/record/updateStatus`,
          obj
        )
        .then(async ({ data: { code } }) => {
          if (code === 0) {
            that.$message({
              message: '操作成功',
              type: 'success'
            })
            this.activeTip.visible = false
            await that.getInfo()
            // 全部确认后弹出去下单弹窗
            if (this.info.status === 3 && this.activeTip.status === 3) {
              this.$confirm(
                `您已经全部确认了选型询价结果，如需下单请点击去下单`,
                '温馨提示',
                {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  type: 'warning'
                }
              )
                .then(() => {
                  // 跳转去下单
                  this.goSubmit()
                })
                .catch(() => {})
            }
          }
        })
    },
    // 当前页
    pageCurrentChangeHandle (val) {
      this.dataForm.page = val
      this.getDataList()
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList()
    },
    getDataList () {
      const obj = {
        page: this.dataForm.page,
        limit: this.dataForm.limit,
        lectotypeInquiryNo: this.info.lectotypeInquiryNo
      }
      const that = this
      this.$http
        .post(`/front/commodity/web/lectotypeInquiry/record/listByPage`, obj)
        .then(({ data: { code, data } }) => {
          if (code === 0) {
            console.log(data)
            that.dataList = data.dataList
            that.total = +data.count
          }
        })
    },
    async getInfo () {
      const that = this
      await this.$http
        .get(
          `/front/commodity/manager/lectotypeInquiry/getDetailById?id=${this.id}`
        )
        .then(({ data: { code, data } }) => {
          if (code === 0) {
            console.log(data)
            that.info = data
            that.getDataList()
          }
        })
    },
    getRecordStatusLabel (val) {
      if (!val && val !== 0) {
        return '-'
      }
      const item = this.recordStatus.find((i) => i.value === val)
      if (!item.label) {
        return '-'
      } else {
        return item.label
      }
    },
    getCustomerStatusLabel (val) {
      if (!val) {
        return '-'
      }
      const item = this.customerStatus.find((i) => i.value === val + '')
      if (!item.label) {
        return '-'
      } else {
        return item.label
      }
    },
    // 去下单
    goSubmit () {
      // 查询所有待下单的数据
      const obj = {
        page: 1,
        limit: 999,
        lectotypeInquiryNo: this.info.lectotypeInquiryNo,
        recordStatusList: [3]
      }
      this.$http
        .post(`/front/commodity/web/lectotypeInquiry/record/listByPage`, obj)
        .then(({ data: { code, data } }) => {
          if (code === 0) {
            const shoppingCartFormList = []
            data.dataList.forEach((item) => {
              shoppingCartFormList.push({
                goodsSpuId: item.skuSpuId,
                goodsSkuId: item.skuId,
                goodsNum: item.number,
                sellingPrice: item.quotePrice,
                moq: item.moq || undefined
              })
            })

            this.$router.push({
              name: 'createOrder',
              query: {
                lectotypeInquiryNo: this.info.lectotypeInquiryNo,
                orderSource: '10',
                shoppingCartFormList: JSON.stringify(shoppingCartFormList)
              }
            })
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.productSelection {
  .w-full {
    width: 100%;
  }

  .topBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    h3 {
      margin: 0;
      margin-bottom: 12px;
    }
  }
}
</style>
